import { render, staticRenderFns } from "./TeamSelectMenu.vue?vue&type=template&id=01ccb55a"
import script from "./TeamSelectMenu.vue?vue&type=script&lang=js"
export * from "./TeamSelectMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports